<template>
  <div class="dealer-rating">
    <StarRating :reviewRating="reviewRating" :reviewCount="reviewCount"/>
  </div>
</template>

<script>
import StarRating from '@/components/StarRating.vue'

export default {
  name: 'DealerRating',
  props: {
    reviewRating: {
      type: Number
    },
    reviewCount: {
      type: Number
    }
  },
  components: {
    StarRating
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .dealer-rating {
    font-family: $font-title;
    display: flex;
  }
</style>
